import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IStore } from 'store/reducers';
import { User } from 'models/User';

export const LinkRouter: React.FC<LinkProps> = ({ children, to, onClick }) => {
  const currentUser = useSelector<IStore, User | null>((state: IStore) => state.users.currentUser);
  const token = useSelector<IStore, string | null>((state) => state.authAgency.token);
  return (
    <Link style={{ pointerEvents: currentUser || token ? 'auto' : 'none' }} to={to} onClick={onClick}>
      {children}
    </Link>
  );
};
